module.exports = __webpack_public_path__ + "img/angle_255.7b66fe05.jpg";